import * as grid from 'view/styles/grid';
import * as transitions from 'view/styles/transitions';

export const EXPAND_TIME_MS = transitions.speedMs.medium;
export const SIDEBAR_WIDTH_LARGE_MULTIPLIER: number = 50;
export const SIDEBAR_WIDTH_LARGE_VIEWPORT = grid.multiple(SIDEBAR_WIDTH_LARGE_MULTIPLIER).px;
export const SIDEBAR_HEIGHT_SMALL_VIEWPORT = '40vh';
export const TAG_BUTTON_HEIGHT = grid.unitless * 5;
